/**
 * Check if mop is non changeable
 * @param {String} billing - User's billing info
 * @return {Boolean} - True if valid or false if not valid
 * @public
 */
export function isNonChangeableMop(billing) {
  return (
    billing &&
    billing.subscriptions &&
    billing.subscriptions.length &&
    billing.subscriptions[0].info &&
    billing.subscriptions[0].info.length &&
    billing.subscriptions[0].info[0].configuration &&
    !billing.subscriptions[0].info[0].configuration.deactivationAllowed &&
    billing.subscriptions[0].requestedState !== "Self-deactivated" &&
    billing.subscriptions[0].type !== "SVOD ST" &&
    billing.subscriptions[0].type !== "SVOD SD"
  );
}
